module.exports = "/assets/data/19ff4030d18f26bbc8c2f835149921ea-BN9.data.json";